import React from 'react';
import PropTypes from 'prop-types';

export default function CheckIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 35.154 24.362'
      className={className}
    >
      <path
        id='Caminho_12160'
        data-name='Caminho 12160'
        d='M928.618,803.333l-20.6,20.6-9.8-9.8a1.391,1.391,0,1,0-1.967,1.967l10.787,10.787a1.4,1.4,0,0,0,1.97,0L930.591,805.3a1.393,1.393,0,0,0-1.973-1.967Z'
        transform='translate(-895.845 -802.925)'
        fill={fill}
      />
    </svg>
  );
}

CheckIcon.defaultProps = {
  fill: '#41a152',
  width: 35.154,
  height: 24.362
};

CheckIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
